import { render, staticRenderFns } from "./IconSizeProperty.vue?vue&type=template&id=7f9c2b0c&"
import script from "./IconSizeProperty.vue?vue&type=script&lang=js&"
export * from "./IconSizeProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports